import React, { FC } from "react";
import KlassyIcon from "../../assets/klassy.svg";
import "./KlassyAvatar.scss";

type KlassyAvatarSize = "small" | "medium" | "large";

type Props = {
  size?: KlassyAvatarSize;
};

const KlassyAvatar: FC<Props> = ({ size = "medium" }) => {
  return (
    <img src={KlassyIcon} alt="Klassy" className={`klassy-avatar ${size}`} />
  );
};

export default KlassyAvatar;
